import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { useMotionConfig } from "./useMotionConfig";

const MotionBox = motion(Box);

const directions = {
  up: { y: 48, x: 0 },
  down: { y: -48, x: 0 },
  left: { x: 48, y: 0 },
  right: { x: -48, y: 0 },
  none: { x: 0, y: 0 },
};

/**
 * Fades + slides content into view on scroll. Used everywhere to create
 * the "elements appear with fade + slide" effect requested for the site.
 */
export default function Reveal({
  children,
  direction = "up",
  delay = 0,
  duration = 0.7,
  amount = 0.25,
  once = true,
  sx,
  ...rest
}) {
  const { disabled } = useMotionConfig();
  const offset = directions[direction] || directions.up;

  if (disabled) {
    return (
      <Box sx={sx} {...rest}>
        {children}
      </Box>
    );
  }

  return (
    <MotionBox
      sx={sx}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.21, 0.6, 0.27, 0.97] }}
      {...rest}
    >
      {children}
    </MotionBox>
  );
}
